module.exports = __webpack_public_path__ + "img/tabs.f4aff3f9.jpg";